import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../src/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_cookieuniversalnuxt_5a7bd79a from 'nuxt_plugin_cookieuniversalnuxt_5a7bd79a' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_plugintemplate_2cf9d41a from 'nuxt_plugin_plugintemplate_2cf9d41a' // Source: ./plugin.template.js (mode: 'all')
import nuxt_plugin_router_49d3adfd from 'nuxt_plugin_router_49d3adfd' // Source: ./router.js (mode: 'all')
import nuxt_plugin_iconfont_2c632d9e from 'nuxt_plugin_iconfont_2c632d9e' // Source: ../src/assets/icon-font/iconfont.js (mode: 'client')
import nuxt_plugin_common_17412eac from 'nuxt_plugin_common_17412eac' // Source: ../src/plugins/common.ts (mode: 'client')
import nuxt_plugin_filters_2dd71148 from 'nuxt_plugin_filters_2dd71148' // Source: ../src/plugins/filters.ts (mode: 'all')
import nuxt_plugin_vantui_40a35cf3 from 'nuxt_plugin_vantui_40a35cf3' // Source: ../src/plugins/vant-ui.ts (mode: 'all')
import nuxt_plugin_customerservice_948d731e from 'nuxt_plugin_customerservice_948d731e' // Source: ../src/plugins/customer-service.ts (mode: 'client')
import nuxt_plugin_shippingbag_697498ee from 'nuxt_plugin_shippingbag_697498ee' // Source: ../src/plugins/shipping-bag.ts (mode: 'client')
import nuxt_plugin_sensors_1f26aeec from 'nuxt_plugin_sensors_1f26aeec' // Source: ../src/plugins/sensors.ts (mode: 'client')
import nuxt_plugin_ddQuery_bfd18676 from 'nuxt_plugin_ddQuery_bfd18676' // Source: ../src/plugins/ddQuery.js (mode: 'client')
import nuxt_plugin_vConsole_75b87dc0 from 'nuxt_plugin_vConsole_75b87dc0' // Source: ../src/plugins/vConsole.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"fade","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Under Armour|安德玛中国官网 - 安德玛(UA)运动品牌","htmlAttrs":{"lang":"en"},"meta":[{"charset":"utf-8"},{"hid":"viewport","name":"viewport","content":"width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"},{"hid":"http-equiv","content":"http-equiv=X-UA-Compatible content=IE=edge,chrome=1"},{"hid":"renderer","name":"renderer","content":"content=webkit"},{"hid":"msapplication-tap-highlight","name":"msapplication-tap-highlight","content":"msapplication-tap-highlight content=no"},{"hid":"apple-mobile-web-app-capable","name":"apple-mobile-web-app-capable","content":"yes"},{"hid":"description","name":"description","content":"安德玛(UA)运动品牌中国官方商城网站,提供最新的安德玛(UA)运动服装,运动衣,紧身衣,运动裤,运动鞋,篮球鞋,跑鞋,训练鞋及运动包,帽等专业体育运动装备,美国高端运动科技品牌Under Armour领先科技产品设计让运动者更强!"},{"hid":"keywords","name":"keywords","content":"安德玛,UA,Under Armour,美国运动品牌,UA官网,安德玛中国官网"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"dns-prefetch","href":"\u002F\u002Falicdn.com"},{"rel":"dns-prefetch","href":"\u002F\u002Fbokecc.com"},{"rel":"dns-prefetch","href":"\u002F\u002Faliyun.com"},{"rel":"dns-prefetch","href":"\u002F\u002Ftingyun.com"},{"rel":"dns-prefetch","href":"\u002F\u002Falibaba.com"},{"rel":"dns-prefetch","href":"\u002F\u002Fsensorsdata.cn"}],"script":[{"type":"text\u002Fjavascript","src":"\u002Flib\u002Ftingyun.js","defer":true},{"type":"text\u002Fjavascript","src":"\u002Flib\u002FbaiduAnalytics.js","defer":true},{"src":"https:\u002F\u002Fg.alicdn.com\u002FAWSC\u002FAWSC\u002Fawsc.js","defer":true,"type":"text\u002Fjavascript"},{"type":"text\u002Fjavascript","innerHTML":"function onCCH5PlayerLoaded() {window.ccH5PlayerJsLoaded = true;}","body":false,"defer":true},{"type":"text\u002Fjavascript","src":"https:\u002F\u002Fp.bokecc.com\u002Fplayer?siteid=25514C0A4CE9E23F&newversion=true","defer":true},{"src":"\u002F\u002Fres.wx.qq.com\u002Fopen\u002Fjs\u002Fjweixin-1.6.0.js","type":"text\u002Fjavascript","async":true}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_cookieuniversalnuxt_5a7bd79a === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_5a7bd79a(app.context, inject)
  }

  if (typeof nuxt_plugin_plugintemplate_2cf9d41a === 'function') {
    await nuxt_plugin_plugintemplate_2cf9d41a(app.context, inject)
  }

  if (typeof nuxt_plugin_router_49d3adfd === 'function') {
    await nuxt_plugin_router_49d3adfd(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_iconfont_2c632d9e === 'function') {
    await nuxt_plugin_iconfont_2c632d9e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_common_17412eac === 'function') {
    await nuxt_plugin_common_17412eac(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_2dd71148 === 'function') {
    await nuxt_plugin_filters_2dd71148(app.context, inject)
  }

  if (typeof nuxt_plugin_vantui_40a35cf3 === 'function') {
    await nuxt_plugin_vantui_40a35cf3(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_customerservice_948d731e === 'function') {
    await nuxt_plugin_customerservice_948d731e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_shippingbag_697498ee === 'function') {
    await nuxt_plugin_shippingbag_697498ee(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sensors_1f26aeec === 'function') {
    await nuxt_plugin_sensors_1f26aeec(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_ddQuery_bfd18676 === 'function') {
    await nuxt_plugin_ddQuery_bfd18676(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vConsole_75b87dc0 === 'function') {
    await nuxt_plugin_vConsole_75b87dc0(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
